export default class EventsRmc{
    
    constructor(element) {
        this._wrapper = element;
        this._btns = this._wrapper.querySelectorAll('.js-events-rmc-filter');
        this._ajaxWrapper = this._wrapper.querySelector('.js-events-rmc-ajax');
        this._btnSubmit = this._wrapper.querySelector('.js-events-rmc-submit');
        this._loader = this._wrapper.querySelector('.loader')
        
        
        this.values = {
            im : [],
            looking_for : [],
            regions : [],
        }
        
        this.bindEvents();
    }
    
    bindEvents(){
        app.nodesEventListener('click', this._btns, (el,n,e) => {
            el.classList.toggle('is-active');
            let values = el.getAttribute('data-value');
            values = values.split(',');
            values.forEach((value) => {
                const index = this.values[el.getAttribute('data-type')].indexOf(value);
                if (index !== -1) {
                    this.values[el.getAttribute('data-type')].splice(index, 1);
                } else {
                    this.values[el.getAttribute('data-type')].push(value);
                }
            });
            
            let has_values = this._wrapper.querySelectorAll('.js-events-rmc-filter.is-active');
            if(has_values.length){
                this._btnSubmit.classList.remove('d-none');
            }
            else{
                this._btnSubmit.classList.add('d-none');
            }
            
        });
        
        this._btnSubmit.addEventListener('click', (el) => {
            this._loader.classList.remove('d-none');
            this._ajaxWrapper.innerHTML = '';
            
            const formData = new FormData();
            formData.append('action', 'submit_find_events_rmc');
            formData.append('values', JSON.stringify(this.values));

            fetch(ajaxurl, {
                method: 'POST',
                body: formData,
            })
                .then(response => {
                    if (!response.ok) throw new Error('Erreur réseau');
                    return response.text(); 
                })
                .then(data => {
                    this._loader.classList.add('d-none');
                    if (this._ajaxWrapper) {
                        this._ajaxWrapper.innerHTML = data;
                    }
                })
                .catch(error => {
                    console.error('Erreur AJAX :', error);
                });
        });
        
    }
    
}